import { useState } from 'react'
import { useParams, NavLink, Outlet } from 'react-router-dom'
import { PageHeader } from '@/components/layout'
import { Button } from '@/components/ui'
import { cn } from '@/lib/utils'
import { UserPlus } from 'lucide-react'

const tabs = [
  { label: 'Members', href: '' },
  { label: 'Invites', href: '/invites' },
  { label: 'Roles', href: '/roles' },
]

export function TeamLayout() {
  const { orgSlug } = useParams()
  const baseUrl = `/orgs/${orgSlug}/team`

  return (
    <div>
      <PageHeader
        title="Team"
        description="Manage organization members and roles"
        action={
          <Button>
            <UserPlus className="mr-2 h-4 w-4" />
            Invite Member
          </Button>
        }
      />

      {/* Tabs */}
      <div className="border-b border-[var(--border-subtle)] mb-6">
        <nav className="-mb-px flex gap-1">
          {tabs.map((tab) => (
            <NavLink
              key={tab.href}
              to={`${baseUrl}${tab.href}`}
              end={tab.href === ''}
              className={({ isActive }) =>
                cn(
                  'border-b-2 px-4 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'border-[var(--accent)] text-[var(--accent)]'
                    : 'border-transparent text-[var(--text-secondary)] hover:border-[var(--border-default)] hover:text-[var(--text-primary)]'
                )
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </div>

      <Outlet />
    </div>
  )
}
